import { hatelist } from './forumApi';
import { FlashMessage } from '@components';
import * as Sentry from '@sentry/browser';

interface ResponseSuccess {
  state: boolean;
}

export const initForumHateList = (threadId: string): void => {
  document.addEventListener('click', async (event: MouseEvent) => {
    const target = event.target as HTMLElement;
    const hateButton = target.closest('[data-to-hate-list]');

    if (!hateButton) {
      return;
    }

    event.preventDefault();

    const userId = hateButton.getAttribute('data-to-hate-list');
    const way = hateButton.getAttribute('data-to-hate-list-way'); // hate or unhate

    if (!userId || !way) {
      return;
    }

    try {
      const formData = new FormData();
      formData.append('op', way);
      formData.append('hate', userId);

      const response = await fetch(hatelist(threadId), {
        method: 'POST',
        body: formData,
      });

      const data: ResponseSuccess = await response.json();

      if (data.state) {
        // Vizuální feedback podle akce
        const button = hateButton as HTMLElement;
        const buttonText = button.querySelector('.typography');
        if (way === 'hate') {
          if (buttonText) buttonText.textContent = 'Blokován';
          button.setAttribute('data-to-hate-list-way', 'unhate');
          await FlashMessage({
            msg: 'Uživatel byl přidán na seznam blokovaných.',
            type: 'success',
          });
        } else {
          if (buttonText) buttonText.textContent = 'Blokovat';
          button.setAttribute('data-to-hate-list-way', 'hate');
          await FlashMessage({
            msg: 'Uživatel byl odebrán ze seznamu blokovaných.',
            type: 'success',
          });
        }
      } else {
        throw new Error('Neúspěšná odpověď ze serveru');
      }
    } catch (error) {
      await FlashMessage({
        msg: 'Akci se nepodařilo zpracovat.',
        type: 'error',
      });
      Sentry.captureException(
        `forumHateList: Akci se nepodařilo zpracovat. Original error: ${error}`
      );
    }
  });
};
